const url = window.location.href
if (url.includes('collections')) {
  let collectionPageTimesVisited = localStorage.getItem(
    'collection_page_times_visited',
  )

  if (collectionPageTimesVisited === null) {
    collectionPageTimesVisited = 0
  }

  collectionPageTimesVisited++

  localStorage.setItem(
    'collection_page_times_visited',
    collectionPageTimesVisited,
  )

  const productListItems = document.querySelector('.prd-List_Items')

  /* eslint-disable */
  if (
    localStorage.getItem('collection_page_times_visited') == 1 ||
    localStorage.getItem('collection_page_times_visited') == 2
  ) {
    productListItems.classList.add('prd-List_Items-active')
  } else {
    productListItems.classList.remove('prd-List_Items-active')
  }
  /* eslint-enable */
}
